// services/backtestService.js
import axios from 'axios';

// ✅ Use environment variable instead of hardcoded localhost
const API_BASE = process.env.REACT_APP_API_BASEURL || 'http://localhost:3005';
const API = `${API_BASE}/api/backtest`;

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token } : {};
};

// Helper to get userId from localStorage
const getUserId = () => {
  const userId = localStorage.getItem('userId');
  return userId ? parseInt(userId, 10) : null;
};

// ✅ Submit backtest - includes userId automatically
const submit = async (params) => {
  const userId = getUserId();
  const res = await axios.post(API, { ...params, userId }, {
    headers: getAuthHeaders()
  });
  return res.data;
};

// ✅ Save backtest result
async function saveResult(payload) {
  const userId = getUserId();
  const { data } = await axios.post(`${API}/save`, { ...payload, userId }, {
    headers: getAuthHeaders()
  });
  return data;
}

// ✅ GET /api/backtest/status/:jobId
const getStatus = async (jobId) => {
  const res = await axios.get(`${API}/status/${jobId}`, {
    headers: getAuthHeaders()
  });
  return res.data;
};

// ✅ GET /api/backtest/recent - auto-includes userId
const getResults = async (limit = 10) => {
  const userId = getUserId();
  const res = await axios.get(`${API}/recent`, { 
    params: { userId, limit },
    headers: getAuthHeaders()
  });
  return res.data;
};

// ✅ GET /api/backtest/:id
const getDetail = async (id) => {
  const res = await axios.get(`${API}/${id}`, {
    headers: getAuthHeaders()
  });
  return res.data;
};

// ✅ DELETE /api/backtest/:id
const deleteResult = async (id) => {
  const userId = getUserId();
  const res = await axios.delete(`${API}/${id}`, {
    params: { userId },
    headers: getAuthHeaders()
  });
  return res.data; // { ok: true, id }
};

// ✅ GET /api/backtest/active - auto-includes userId
const getActive = async () => {
  const userId = getUserId();
  const res = await axios.get(`${API}/active`, { 
    params: { userId },
    headers: getAuthHeaders()
  });
  return res.data; // {active, jobId, status, progress}
};

// ✅ Cancel backtest
const cancel = async (jobId) => {
  if (!jobId) throw new Error('Missing jobId');
  try {
    const res = await axios.post(`${API}/cancel/${encodeURIComponent(jobId)}`, {}, {
      headers: getAuthHeaders()
    });
    return res.data;
  } catch (err) {
    // Fallback for servers that use a JSON body instead of a URL param
    if (err?.response?.status === 404) {
      const res2 = await axios.post(`${API}/cancel`, { jobId }, {
        headers: getAuthHeaders()
      });
      return res2.data;
    }
    throw err;
  }
};

export default {
  submit,
  getStatus,
  saveResult,
  getResults,
  getDetail,
  deleteResult,
  cancel,
  getActive
};